import http from "@/http-common";

export default class MA201040Service {

	getList(_params) {
		return http.get('/ma/ma201040', { params: _params}).then(res => res.data);
	}

	updateList(_data)
	{
		// 배열을 JSON.Stringify 함수로 처리 해준 후 요청
		return http.patch('/ma/ma201040', JSON.stringify(_data)).then(res => res.data);

		// 아래와 같이 사용하면 오류가 발생함 data 태그 없이 값만 넘겨야 함
		// return http.patch('/ma/ma201040', {data:JSON.stringify(_data)}).then(res => res.data);
	}

}